export const ModuleInfo = {
  Tables: {
    ModulesContentPages: 'ModulesContentPages',
    ModulesContentPagesPosts: 'ModulesContentPagesPosts',
    ModulesContentPagesPostsComments: 'ModulesContentPagesPostsComments',
    ModulesContentPagesPostsImages: 'ModulesContentPagesPostsImages',
    ModulesTeamMembers: 'ModulesTeamMembers',    
    ModulesTeamMembersPersons: 'ModulesTeamMembersPersons',
    ModulesImageGalleries: 'ModulesImageGalleries',
    ModulesImageGalleriesAlbums: 'ModulesImageGalleriesAlbums',
    ModulesImageGalleriesAlbumsImages: 'ModulesImageGalleriesAlbumsImages',
    SubscriptionsAppImages: 'SubscriptionsAppImages',
    LastSyncInfo: 'LastSyncInfo',
    UserActionQueue: 'UserActionQueue',
    ReportingAppSessions: 'ReportingAppSessions',
    ReportingPageViews: 'ReportingPageViews',
    ReportingRegisteredApps: 'ReportingRegisteredApps',
    ReportingUserLikes: 'ReportingUserLikes',
    ReportingUserFavourite: 'ReportingUserFavourite',
    ModulesRadioStream: 'ModulesRadioStream',
    SubscriptionsDesignSettings: 'SubscriptionsDesignSettings',
    SubscriptionsStartPages: 'SubscriptionsStartPages',
    SubscriptionsModules: 'SubscriptionsModules',
    ModulesForms: 'ModulesForms',
    ModulesYoutube: 'ModulesYoutube',
    ModulesFacebook:'ModulesFacebook',
    ModulesTwitter:'ModulesTwitter',
    ModulesInstagram:'ModulesInstagram',
    ModulesWebsite:'ModulesWebsite',
    ModulesRSSFeed:'ModulesRSSFeed',
    ModulesChats:'ModulesChats',
    ModulesCustomCode:'ModulesCustomCode',
    ModulesPDF:'ModulesPDF'
  },
  Primarykey: {
    Id: 'Id',
    SubscriptionModule_Id: 'SubscriptionModule_Id',
    ModulesTeamMembers_Id: 'ModulesTeamMembers_Id',
    ModulesContentPagesPosts_Id: 'ModulesContentPagesPosts_Id',
    ModulesContentPages_Id: 'ModulesContentPages_Id',
    ModuleActivationId: 'ModuleActivationId'
  },
  Modules: {
    Imprint: {
      moduleId: -100,
      moduleName: '/app-info/',
      moduleUrl: '/app-info/'
    },
    MainMenu: {
      moduleId: -101,
      moduleName: 'mainmenu-view'
    },
    SubMenu: {
      moduleId: 0,
      moduleName: 'submenu-view'
    },
    News: {
      moduleId: 1,
      moduleName: 'news-view'
    },
    Event: {
      moduleId: 2,
      moduleName: 'event-view'
    },
    ContactDetails: {
      moduleId: 3,
      moduleName: 'contact-detail-view'
    },
    AboutUs: {
      moduleId: 4,
      moduleName: 'about-us-view'
    },
    ContactForm: {
      moduleId: 5,
      moduleName: 'contact-form-view'
    },
    Map: {
      moduleId: 6,
      moduleName: 'map-view'
    },
    Team: {
      moduleId: 7,
      moduleName: 'team-view'
    },

    OpeningHours: {
      moduleId: 8,
      moduleName: 'opening-hors-view'
    },
    Milestone: {
      moduleId: 9,
      moduleName: 'milestones-view'
    },
    Facebook: {
      moduleId: 10,
      moduleName: 'facebook-view'
    },
    Twitter: {
      moduleId: 11,
      moduleName: 'twitter-view'
    },
    TextContent: {
      moduleId: 12,
      moduleName: 'text-content-view'
    },
    ImageContent: {
      moduleId: 13,
      moduleName: 'image-content-view'
    },
    ClicktoCall: {
      moduleId: 14,
      moduleName: 'click2call-view'
    },
    ClicktoEmail: {
      moduleId: 15,
      moduleName: 'click2email-view'
    },
    Youtube: {
      moduleId: 16,
      moduleName: 'youtube-view'
    },
    Website: {
      moduleId: 17,
      moduleName: 'website-view'
    },
    RssFeed: {
      moduleId: 18,
      moduleName: 'rssfeed-view'
    },
    ImageGallery: {
      moduleId: 19,
      moduleName: 'image-gallery-view'
    },
    CustomForm: {
      moduleId: 49,
      moduleName: 'custom-form-view'
    },
    Appoinment: {
      moduleId: 22,
      moduleName: 'appointment-view'
    },
    Copoun: {
      moduleId: 23,
      moduleName: 'coupons-view'
    },
    Pdf: {
      moduleId: 24,
      moduleName: 'pdf-view'
    },
    Feedback: {
      moduleId: 26,
      moduleName: 'rating-feedback-view'
    },
    RoomReservation: {
      moduleId: 27,
      moduleName: 'appointment-view'
    },
    TableReservation: {
      moduleId: 28,
      moduleName: 'appointment-view'
    },
    TicketReservation: {
      moduleId: 29,
      moduleName: 'appointment-view'
    },
    Loyality: {
      moduleId: 31,
      moduleName: 'loyality-view'
    },
    Radio: {
      moduleId: 34,
      moduleName: 'radio-view'
    },
    CodeEditor: {
      moduleId: 51,
      moduleName: 'custom-code-view'
    },
    Login: {
      moduleId: 38,
      moduleName: 'login-view'
    },
    Chat: {
      moduleId: 39,
      moduleName: 'chat-view'
    },
    Instagram: {
      moduleId: 50,
      moduleName: 'instagram-view'
    },
    NewsDeatil: {
      moduleId: 101,
      moduleName: 'news-detail-view'
    },
    LoyalityPin: {
      moduleId: 102,
      moduleName: 'loyality-pin-view'
    },
    LoyalityQR: {
      moduleId: 103,
      moduleName: 'loyality-qr-view'
    },
    CopounPin: {
      moduleId: 104,
      moduleName: 'coupon-pin-view'
    },
    CopounQR: {
      moduleId: 105,
      moduleName: 'coupon-qr-view'
    },
    YoutubeDetail: {
      moduleId: 106,
      moduleName: 'youtube-detail-view'
    },
    YoutubePlay: {
      moduleId: 107,
      moduleName: 'youtube-play-view'
    },
    RssDetail: {
      moduleId: 108,
      moduleName: 'rss-detail-view'
    },
    RssWebsite: {
      moduleId: 109,
      moduleName: 'rss-website-view'
    },
    FacebookDetail: {
      moduleId: 110,
      moduleName: 'facebook-post-view'
    },
    ImageGalleryScroll: {
      moduleId: 111,
      moduleName: 'image-gallery-scroll-view'
    },
    ImagegalleryZoomPinch: {
      moduleId: 112,
      moduleName: 'image-gallery-zoom-pinch-view'
    },
    EventDetail: {
      moduleId: 201,
      moduleName: 'event-detail-view'
    },
    EventWebsite: {
      moduleId: 202,
      moduleName: 'event-website-view'
    },
    lockview:
    {
      moduleId: 100000,
      moduleName: 'lock-view'
    },
    AppImages: {
      moduleId: -1002
    },
    BootySync: {
      moduleId: -1001
    },
    AppConfig: {
      moduleId: -1003
    }
  }

}



// WEBPACK FOOTER //
// ./src/config/nameConfig.js